module.exports = "/fonts/tarra-logotype-l-9587d9d9cd1b8618fa6c19e2b5fe8e46.svg";